import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SearchInstrumentation" */ './lazyIndex'),
    { name: 'SearchInstrumentation' }
);

// V1 events
export const lazyLogEntityClicked: LazyAction<
    typeof lazyIndex.logEntityClicked,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logEntityClicked);
export const lazyLogResponseReceived: LazyAction<
    typeof lazyIndex.logResponseReceived,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logResponseReceived);
export const lazyLogSessionEnd: LazyAction<typeof lazyIndex.logSessionEnd, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.logSessionEnd);
export const lazyLogResponseRendered: LazyAction<
    typeof lazyIndex.logResponseRendered,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logResponseRendered);
export const lazyLogSearchBoxStateChanged: LazyAction<
    typeof lazyIndex.logSearchBoxStateChanged,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchBoxStateChanged);
export const lazyLogSearchResultInteraction: LazyAction<
    typeof lazyIndex.logSearchResultInteraction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchResultInteraction);
export const lazyLogResponseNeverRendered: LazyAction<
    typeof lazyIndex.logResponseNeverRendered,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logResponseNeverRendered);
export const lazyFlushNonRenderedItemsFromCache: LazyAction<
    typeof lazyIndex.flushNonRenderedResponseReceivedItemsFromCache,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.flushNonRenderedResponseReceivedItemsFromCache);

// V2 events
export const lazyLogCachedContentRendered: LazyAction<
    typeof lazyIndex.logCachedContentRendered,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logCachedContentRendered);
export const lazyLogClientLayout: LazyAction<typeof lazyIndex.logClientLayout, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.logClientLayout);
export const lazyLogClientDataSource: LazyAction<
    typeof lazyIndex.logClientDataSource,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logClientDataSource);
export const lazyLogEntitiesFromFilePicker: LazyAction<
    typeof lazyIndex.logEntitiesFromFilePicker,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logEntitiesFromFilePicker);
export const lazyLogResponseReceivedV2: LazyAction<
    typeof lazyIndex.logResponseRecievedV2,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logResponseRecievedV2);
export const lazyLogResultsRendered: LazyAction<
    typeof lazyIndex.logResultsRendered,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logResultsRendered);
export const lazyLogSearchEntityActions: LazyAction<
    typeof lazyIndex.logSearchEntityActions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchEntityActions);
export const lazyLogSearchFeedbackActions: LazyAction<
    typeof lazyIndex.logSearchFeedbackActions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchFeedbackActions);
export const lazyLogSearchActions: LazyAction<
    typeof lazyIndex.logSearchActions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchActions);
export const lazyLogSecondaryEntityActionClicked: LazyAction<
    typeof lazyIndex.logSecondaryEntityActionClicked,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSecondaryEntityActionClicked);
export const lazyClearProcessedTraceIds: LazyAction<
    typeof lazyIndex.clearProcessedTraceIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearProcessedTraceIds);
export const lazyLogSearchSuggestionsClientLayoutEvent: LazyAction<
    typeof lazyIndex.logSearchSuggestionsClientLayoutEvent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchSuggestionsClientLayoutEvent);
export const lazyLogSearchSuggestionsResultsRenderedEvent: LazyAction<
    typeof lazyIndex.logSearchSuggestionsResultsRenderedEvent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logSearchSuggestionsResultsRenderedEvent);
export const lazyLogCounterfactualInformation: LazyAction<
    typeof lazyIndex.logCounterfactualInformation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logCounterfactualInformation);

// Types
export type { Results } from './data/schema/ClientDataSourceEvent';
export type { ClientDataSourceEvent } from './data/schema/ClientDataSourceEvent';
export type { default as ResultsView } from './data/schema/ResultsView';
export type { GroupName } from './data/schema/substrateSearchLogTypes';
export type { ItemType } from './data/schema/substrateSearchLogTypes';
export type {
    CopilotAnswerEntityActionType,
    EntityActionTakenType,
    SearchEntityActionsMetadata,
} from './data/schema/substrateSearchLogTypes';
